<template>

  <div class="list-products">
     <KTCodePreview v-bind:title="'Danh sách sản phẩm'"
      > <template v-slot:toolbar
        > <b-row
          > <b-dropdown
            size="sm"
            right
            > <template slot="button-content"
              > <i
                style="font-size: 1rem"
                class="fas fa-cog"
              ></i
              > <span class="font-weight-bolder">Thao tác</span> </template
            > <b-dropdown-item @click="excelModal"
              > <span
                > <i
                  style="font-size: 1rem"
                  class="far fa-file-excel"
                ></i
                > &nbsp; Xuất Excel</span
              > </b-dropdown-item
            > <b-dropdown-item
              v-if="checkPermission('PRODUCT_UPDATE_PRICE')"
              @click="routeProduct('product-store-pricing-import')"
              > <span
                > <i
                  style="font-size: 1rem"
                  class="fas fa-tags"
                ></i
                > &nbsp; Cấu hình giá</span
              > </b-dropdown-item
            > <b-dropdown-item @click="onClickToPrint"
              > <span
                > <i
                  style="font-size: 1rem"
                  class="fas fa-print"
                ></i
                > &nbsp; In sản phẩm</span
              > </b-dropdown-item
            > </b-dropdown
          > <b-button
            size="sm"
            variant="info"
            class="ml-4 font-weight-bolder"
            @click="routeProduct('copy-products')"
          >
            <i style="font-size: 1rem" class="fas fa-copy mr-1"></i>
            Sao chép sản phẩm
          </b-button>
          <span
            v-if="checkPermission('PRODUCT_INSERT')"
            v-b-tooltip.hover
            :title="isCreateProductBlocked ? createProductBlockedTooltip : ''"
            class="d-inline-block ml-4"
          >
            <b-dropdown
              size="sm"
              right
              split
              variant="primary"
              :disabled="isCreateProductBlocked"
              @click="routeProduct('addProduct')"
              > <template v-slot:button-content
                >
                <div class="font-weight-bolder">
                   <span
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-add-1"
                    ></i
                    >Tạo mới</span
                  >
                </div>
                 </template
              > <b-dropdown-item
                :disabled="isCreateProductBlocked"
                @click="routeProduct('import-product')"
                > <i
                  style="font-size: 1rem"
                  class="far fa-file-excel mr-2"
                ></i
                > <span>Nhập từ file excel</span> </b-dropdown-item
              > </b-dropdown
          > </span
        > </b-row
        > </template
      > <template v-slot:preview
        > <b-row class="mb-5"
          >
          <div class="col">
             <b-input
              size="sm"
              placeholder="Tìm kiếm"
              v-model="search"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input
            >
          </div>

          <div class="col">
             <Autosuggest
              :model="selectedCate"
              :suggestions="filteredCateOptions"
              placeholder="danh mục sản phẩm"
              @select="onSelectedCate"
              @change="onInputCateChange"
              suggestionName="suggestionName"
            />
          </div>

          <div class="col">
             <Autosuggest
              :model="selectedBrandName"
              :suggestions="filteredBrandOptions"
              placeholder="thương hiệu"
              @select="onSelectedBrand"
              @change="onInputBrandChange"
            />
          </div>

          <div class="col">
             <Autosuggest
              :model="searchStock"
              :suggestions="filteredOptions"
              placeholder="kho để kiểm tra tồn"
              @select="onSelected"
              @change="onInputChangeStore"
            />
          </div>

          <div class="col">
             <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedVATRate"
              :options="[
                {
                  id: null,
                  name: 'Chọn thuế',
                },
                {
                  id: -1,
                  name: 'KCT',
                },
                {
                  id: 5,
                  name: '5%',
                },
                {
                  id: 8,
                  name: '8%',
                },
                {
                  id: 10,
                  name: '10%',
                },
              ]"
              value-field="id"
              text-field="name"
              > </b-form-select
            >
          </div>
           </b-row
        > <b-row class="mb-5"
          >
          <div class="col">
             <b-form-select
              size="sm"
              required
              class="select-style"
              v-model="selectedStatus"
              :options="listStatus"
              value-field="id"
              text-field="name"
              disabled-field="notEnabled"
            ></b-form-select
            >
          </div>

          <div class="col">
             <b-form-select
              size="sm"
              required
              class="select-style"
              v-model="selectedProductType"
              :options="listProductType"
              value-field="id"
              text-field="name"
              disabled-field="notEnabled"
            />
          </div>
           <b-col
            > <b-form-select
              size="sm"
              required
              class="select-style"
              v-model="selectedVAT"
              :options="[
                { id: null, name: 'Chọn sản phẩm VAT' },
                { id: 'ne', name: 'Có tên VAT' },
                { id: 'eq', name: 'Chưa có tên VAT' },
              ]"
              value-field="id"
              text-field="name"
              disabled-field="notEnabled"
            /> </b-col
          > <b-col></b-col> <b-col></b-col> </b-row
        > <b-row class="mb-5"
          > <b-col md="1"
            > <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            > </b-col
          > <b-col md="1"
            > <b-button
              style="font-weight: 600; width: auto; min-width: 120px"
              variant="secondary"
              size="sm"
              @click="clearFilters"
              :disabled="activeFilterCount === 0"
              >Xóa bộ lọc <span v-if="activeFilterCount > 0">({{ activeFilterCount }})</span>
              </b-button
            > </b-col
          > <b-col
            >
            <div class="d-flex justify-content-end align-items-start">
              <b-dropdown
                size="sm"
                right
                variant="light"
                class="mr-3"
                text="Cột hiển thị"
              >
                <b-form-checkbox-group
                  v-model="selectedDisplayColumns"
                  :options="columnDisplayOptions"
                  class="px-3 py-2"
                  stacked
                />
              </b-dropdown>

              <p
                class="mt-3 text-dark"
                style="font-weight: 500; font-size: 13px"
              >
                 {{ fromNo }} - {{ toNo }} / {{ convertPrice(totalItem) }}
              </p>

            </div>
             </b-col
          > </b-row
        >
        <div class="table-container">
          <b-table
            :items="listProducts"
            :fields="displayFields"
            class="table-bordered table-hover col-md-12 min-width-table"
            no-local-sorting
            :small="true"
            :busy="onLoading"
            > <template v-slot:table-busy
              > <vcl-table
                :speed="5"
                :animate="true"
                :columns="10"
              ></vcl-table
              > </template
            > <!-- header custom --> <template v-slot:head(selected)
              > <span
                > <b-form-checkbox
                  v-model="checkAllPro"
                  size="lg"
                  @change="checkAll"
                ></b-form-checkbox
                > </span
              > </template
            > <!-- check bõ --> <template v-slot:cell(selected)="row"
              >
              <div class="d-flex justify-content-center">
                 <b-form-checkbox
                  size="lg"
                  v-model="row.item.selected"
                  @change="clickIndex2"
                ></b-form-checkbox
                >
              </div>
               </template
            > <template v-slot:cell(imageUrl)="row"
              > <div class="d-flex justify-content-center align-items-center">
                <ProductImage :src="row.item.imageUrl" />
              </div> </template
            > <template v-slot:cell(count)="row"
              >
              <div
                style="cursor: pointer"
                @click="findParentOrChild(row.item)"
                class="d-flex justify-content-center align-items-center"
              >
                 <v-icon
                  small
                  style="font-size: 13px"
                  v-b-tooltip
                  :title="checkTooltip(row.item)"
                  >{{ checkTypeOfProduct(row.item) }}</v-icon
                >
              </div>
               </template
            > <!-- ma vach --> <template v-slot:cell(barCode)="row"
              >
              <div v-if="row.item.barCode !== ''"> <b v-text="row.item.barCode"></b> </div>

              <div
                v-else
                style="cursor: pointer"
                class="text-center"
              >
                 <v-icon
                  small
                  style="font-size: 13px"
                  v-b-tooltip
                  title="Tạo mã vạch"
                  @click="showGenBarcodeAlert(row.item)"
                  >menu-icon flaticon2-add</v-icon
                >
              </div>
               </template
            > <template v-slot:cell(productCode)="row"
              >
              <div>
                 <a
                  class="font-weight-bold"
                  v-bind:href="getLinkDoc(row.item)"
                  target="_blank"
                  > <span
                    v-text="row.item.productCode"
                    class="d-block product-code-text"
                  ></span
                  > </a
                >
              </div>
               </template
            > <!-- ten sp --> <template v-slot:cell(productName)="row"
              >
              <div>
                 <span
                  v-text="row.item.productName"
                  class="d-block product-name-text"
                ></span
                > <small v-if="row.item.productNameVat && row.item.productNameVat"
                  > <b class="text-warning">Tên VAT: </b><b>{{ row.item.productNameVat }}</b
                  > </small
                >
              </div>
               </template
            > <template v-slot:cell(VAT)="row"
              >
              <div class="text-center">
                 <b v-if="row.item.VAT === VAT_AMOUNT.PERCENT_KCT"> 0% </b> <b
                  v-else-if="row.item.VAT"
                  > {{ row.item.VAT }}%</b
                >
              </div>
               </template
            > <!-- trang thai --> <template v-slot:cell(status)="row"
              > <span
                v-text="checkStatus(row.item.status)"
                class="label font-weight-bold label-lg label-inline"
                v-bind:class="{
                  'label-light-warning': row.item.status === 1,
                  'label-light-danger': row.item.status === 2,
                }"
                style="width: max-content"
              ></span
              > </template
            > <template v-slot:cell(originalPrice)="row"
              >
              <div style="text-align: end">
                 <span v-text="convertPrice(row.item.originalPrice)"></span>
              </div>
               </template
            > <template v-slot:cell(sellingPrice)="row"
              >
              <div
                @mouseover="hoverPrice = true"
                @mouseleave="hoverPrice = false"
                style="text-align: end; cursor: pointer"
                v-if="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
              >
                 <span @click="handleShowPriceModel(row.item)"
                  > <i
                    v-if="hoverPrice"
                    class="fas fa-edit"
                  ></i
                  > </span
                > <span v-text="convertPrice(row.item.sellingPrice)"></span>
              </div>
               <span
                v-text="convertPrice(row.item.sellingPrice)"
                v-else
              ></span
              > </template
            > <template v-slot:cell(totalQuantityInStock)="row"
              >
              <div
                class="productCode"
                style="text-align: center; cursor: pointer"
              >
                 <a
                  class="font-weight-bold"
                  v-bind:href="getLinkDoc(row.item)"
                  target="_blank"
                  > <span v-text="row.item.totalQuantityInStock"></span> </a
                >
              </div>
               </template
            > <template v-slot:cell(totalQuantityInTransfer)="row"
              >
              <div style="text-align: center">
                 <span
                  class="text-warning"
                  v-text="row.item.totalQuantityInTransfer"
                ></span
                >
              </div>
               </template
            > <template v-slot:cell(actions)="row"
              >
              <div class="d-flex justify-content-center">
                 <b-dropdown
                  size="sm"
                  id="dropdown-left"
                  no-caret
                  right
                  boundary="viewport"
                  menu-class="action-menu"
                  class="action-dropdown"
                  :popper-options="{
                    modifiers: {
                      computeStyle: {
                        gpuAcceleration: false,
                      },
                    },
                    onCreate: (data) => {
                      if (data.popper) {
                        data.popper.style.zIndex = '9999'
                      }
                    },
                    onUpdate: (data) => {
                      if (data.popper) {
                        data.popper.style.zIndex = '9999'
                      }
                    },
                  }"
                  > <template slot="button-content"
                    > <i
                      style="font-size: 1rem; padding-right: 0px"
                      class="flaticon2-settings"
                    ></i
                    > </template
                  > <!-- TODO remove if necessary --> <b-dropdown-item
                    @click="handleViewInventoryDetail(row.item)"
                    > <span style="color: #3f4254; font-size: 12px"
                      > <i
                        style="font-size: 10px"
                        class="flaticon2-box-1"
                      ></i
                      > &nbsp; Chi tiết tồn kho </span
                    > </b-dropdown-item
                  > <!-- <b-dropdown-item
                  v-if="checkPermission('STOCK_ADJUST')"
                  @click="updateProductStock(row.item)"
                >
                  <span style="color: #3f4254; font-size: 12px">
                    <i style="font-size: 10px" class="flaticon2-box-1"></i>
                    &nbsp; Cập nhật tồn kho
                  </span>
                </b-dropdown-item> --> <b-dropdown-item
                    @click="editItem(row.item)"
                    v-if="checkViewOnly()"
                    > <span style="color: #3f4254; font-size: 12px"
                      > <i
                        style="font-size: 1rem"
                        class="flaticon-eye"
                      ></i
                      > &nbsp; Chi tiết sản phẩm </span
                    > </b-dropdown-item
                  > <b-dropdown-item
                    @click="editItem(row.item)"
                    v-if="!checkViewOnly()"
                    > <span style="color: #3f4254; font-size: 12px"
                      > <i
                        style="font-size: 1rem"
                        class="flaticon2-pen"
                      ></i
                      > &nbsp; Chỉnh sửa </span
                    > </b-dropdown-item
                  > <b-dropdown-item
                    @click="showDeleteAlert(row.item)"
                    v-if="checkPermission('PRODUCT_DELETE')"
                    > <span style="color: #3f4254; font-size: 12px"
                      > <i
                        style="font-size: 1rem; color: #d33"
                        class="flaticon2-rubbish-bin-delete-button"
                      ></i
                      > &nbsp; Xóa </span
                    > </b-dropdown-item
                  > </b-dropdown
                >
              </div>
               </template
            > </b-table
          >
        </div>
         <template
          > <b-modal
            v-model="showEditPriceModal"
            hide-footer
            :title="productName"
            > <b-row
              class="mb-5"
              v-if="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
              > <b-col
                > <label
                  class="labelInput"
                  for="inputOriginalPrice"
                  >Giá nhập</label
                > <b-form-input
                  v-model="originalPrice"
                  size="sm"
                  placeholder="Nhập giá nhập"
                  v-mask="mask"
                  disabled
                ></b-form-input
                > </b-col
              > </b-row
            > <b-row class="mb-5"
              > <b-col
                > <label
                  class="labelInput"
                  for="inputSellingPrice"
                  >Giá bán</label
                > <b-form-input
                  v-model="sellingPrice"
                  size="sm"
                  placeholder="Nhập giá bán"
                  v-mask="mask"
                ></b-form-input
                > </b-col
              > </b-row
            > <b-row
              v-show="selectedProduct.parentProductId === null"
              class="mb-5"
              > <b-col
                > <b-form-checkbox v-model="checkUpdate"
                  >Cập nhật giá sản phẩm con theo cha</b-form-checkbox
                > </b-col
              > </b-row
            > <b-row
              > <b-col
                > <b-button
                  style="font-weight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  @click="updateProduct"
                  >Lưu</b-button
                > <b-button
                  style="margin-left: 10px; font-weight: 600; width: 70px"
                  variant="secondary"
                  size="sm"
                  @click="handleShowPriceModel"
                  >Hủy</b-button
                > </b-col
              > </b-row
            > </b-modal
          > </template
        > <b-row class="mt-4"
          > <b-col
            >
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
               Tổng số: {{ convertPrice(totalItem) }}
            </p>
             </b-col
          > <b-col
            > <b-pagination-nav
              class="custom-pagination"
              v-if="numberOfPage >= 2"
              :link-gen="linkGen"
              :number-of-pages="numberOfPage"
              use-router
              @change="fetchData"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm m-1"
              prev-class="page-item-prev btn btn-icon btn-sm m-1"
              next-class="page-item-next btn btn-icon btn-sm m-1"
              last-class="page-item-last btn btn-icon btn-sm m-1"
              page-class="btn btn-icon btn-sm border-0 m-1"
              > <template v-slot:first-text
                > <span> <i class="ki ki-double-arrow-back icon-xs"></i> </span> </template
              > <template v-slot:prev-text> <i class="ki ki-arrow-back icon-xs"></i> </template>
              <template v-slot:next-text> <i class="ki ki-arrow-next icon-xs"></i> </template>
              <template v-slot:last-text
                > <span class="text-info"> <i class="ki ki-double-arrow-next icon-xs"></i> </span>
                </template
              > </b-pagination-nav
            > </b-col
          > </b-row
        > </template
      > </KTCodePreview
    > <b-modal
      ref="excel-modal"
      hide-footer
      title="Xuất excel"
      id="excel-modal"
      > <v-form
        ref="form"
        lazy-validation
        >
        <div class="mb-4">

          <div class="row">

            <div class="col-6">
               <b-form-group label="Chọn cột cần xuất:"
                > <b-form-radio-group
                  id="radio-group-excel-1"
                  v-model="selectedRowExcel"
                  name="radio-sub-component-1"
                  @change.native="showHeader"
                  > <b-form-radio value="all">Tất cả</b-form-radio> </b-form-radio-group
                > </b-form-group
              > <b-form-group label="Danh sách cần xuất:"
                > <b-form-radio-group
                  id="radio-group-excel-2"
                  v-model="selectedListExcel"
                  name="radio-sub-component-2"
                  > <b-form-radio value="all">Tất cả các trang</b-form-radio> </b-form-radio-group
                > </b-form-group
              >
            </div>

            <div
              class="col-6"
              v-show="showHeaderExcel"
            >
               <b-form-group
                > <template #label
                  > Cột:<br /> <b-form-checkbox
                    v-model="allSelected"
                    :indeterminate="indeterminate"
                    aria-describedby="products"
                    aria-controls="products"
                    @change="toggleAll"
                    > {{ allSelected ? 'Bỏ chọn tất cả' : 'Tất cả' }} </b-form-checkbox
                  > </template
                > <b-form-checkbox-group
                  id="products"
                  v-model="selectedHeader"
                  :options="optionsHeader"
                  name="products"
                  stacked
                ></b-form-checkbox-group
                > </b-form-group
              >
            </div>

          </div>

        </div>
         <b-button
          style="width: 110px"
          variant="primary"
          size="sm"
          @click="reportClick"
          class="mr-3"
          > <v-icon
            small
            class="text-white"
            v-b-tooltip
            >mdi-download</v-icon
          > <strong>Xuất Excel</strong> </b-button
        > <b-button
          style="width: 100px"
          variant="secondary"
          size="sm"
          @click="$bvModal.hide('excel-modal')"
          > <strong>Hủy</strong> </b-button
        > </v-form
      > </b-modal
    > <ProductStockModal :product="selectingProduct" />
  </div>

</template>

<style lang="scss">
  .list-products {
  min-height: calc(100vh - 220px);
  .labelInput {
    font-weight: 600;
  }
  .productCode:hover {
    text-decoration: underline;
  }

  .inputText {
    width: 22%;
  }
  .btn.btn-icon.btn-sm {
    height: calc(1.35em + 1.1rem + 2px);
    width: auto;
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .dropdown-header {
    color: #3699ff !important;
  }
  .table-container {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    position: relative;
    overflow-x: hidden;
    overflow-y: visible;
    width: 100%;
    max-width: 100%;
  }
  ::v-deep .card-body {
    overflow-x: hidden;
    overflow-y: visible;
    width: 100%;
    max-width: 100%;
  }
  ::v-deep .card {
    overflow-x: hidden;
    overflow-y: visible;
    width: 100%;
    max-width: 100%;
  }
  .action-dropdown {
    position: relative;
    z-index: 1000;
  }
  ::v-deep .action-menu {
    z-index: 9999 !important;
  }
  ::v-deep .action-dropdown.show .dropdown-menu {
    z-index: 9999 !important;
  }
  ::v-deep .action-dropdown .dropdown-menu {
    z-index: 9999 !important;
  }
  .action-dropdown.show {
    z-index: 9999 !important;
    position: relative;
  }
  .table-container td.actionProClass {
    position: relative;
    z-index: 100;
    overflow: visible !important;
  }
  .table-container td.actionProClass .action-dropdown.show {
    z-index: 9999 !important;
  }
  .table-container tr {
    position: relative;
    z-index: 1;
  }
  // Row with open dropdown should be above other rows
  .table-container tr:has(.action-dropdown.show) {
    z-index: 10000 !important;
    position: relative;
  }
  // All cells in row with open dropdown should have high z-index
  .table-container tr:has(.action-dropdown.show) td {
    z-index: 10000 !important;
    position: relative;
  }
  .table-container tr:hover td.actionProClass {
    z-index: 9998;
  }
  // Other rows should stay below dropdown
  .table-container tbody tr:not(:has(.action-dropdown.show)) {
    z-index: 1;
    position: relative;
  }
  // Target dropdown menu rendered by Popper.js
  ::v-deep .dropdown-menu.show {
    z-index: 9999 !important;
  }
  // Ensure all dropdowns in table have high z-index
  .table-container ::v-deep .dropdown-menu {
    z-index: 9999 !important;
  }
  // Override sticky cells z-index when dropdown is open
  .table-container td.selectedProClass,
  .table-container td.sttProClass,
  .table-container td.imageClass {
    z-index: 11;
  }
  // When dropdown is open, ensure it's above sticky cells
  .table-container .action-dropdown.show ~ td {
    z-index: 10;
  }
  // Ensure table rows don't create stacking context that blocks dropdown
  .table-container tbody tr {
    isolation: auto;
  }
  // Row with dropdown should create its own stacking context
  .table-container tbody tr:has(.action-dropdown.show) {
    isolation: isolate;
  }
  // Global fix for dropdown menus (Popper.js renders them in body)
  body > .dropdown-menu.action-menu,
  body > [class*='dropdown-menu'] {
    z-index: 9999 !important;
  }
  // Target Popper.js container
  body > [data-popper-placement],
  body > .dropdown-menu {
    z-index: 9999 !important;
  }
  // Ensure action-menu class has highest priority
  .action-menu.dropdown-menu {
    z-index: 9999 !important;
  }
  // Prevent table rows from blocking dropdown (important for Popper.js)
  .table-container tbody tr {
    pointer-events: auto;
  }
  // When dropdown is open, lower z-index of subsequent rows
  .table-container tbody tr:has(.action-dropdown.show) ~ tr {
    z-index: 0 !important;
  }
  .table-container .table {
    width: 100%;
    max-width: 100%;
    table-layout: auto;
    position: static;
  }
  .table-container .table tbody {
    position: relative;
  }
  .table-container .table-responsive {
    overflow-x: hidden;
    overflow-y: visible;
    width: 100%;
    max-width: 100%;
  }
  .table-container .table-responsive > .table {
    min-width: 0;
    width: 100%;
  }
  // Ensure table doesn't create stacking context that blocks dropdown
  .table-container .table,
  .table-container .table tbody {
    isolation: auto;
  }
  // Prevent table from overflowing container
  .table-container .min-width-table {
    min-width: 0;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
  }
  // Ensure table cells don't cause overflow
  .table-container table td,
  .table-container table th {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
  // Allow some cells to wrap if needed
  .table-container table td.nameProClass,
  .table-container table th.nameProClass,
  .table-container table td.nameNotPriceProClass,
  .table-container table th.nameNotPriceProClass {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  // Ensure action cell doesn't overflow
  .table-container table td.actionProClass,
  .table-container table th.actionProClass {
    overflow: visible !important;
  }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }
  .table.b-table.table-sm
    > thead
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm
    > tfoot
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }
  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>

<style scoped>
  input.form-control {
  border: 1px solid #ced4da;
}
.selectedProClass {
  width: 4%;
  text-align: center;
  position: sticky;
  z-index: 11;
}
.sttProClass {
  width: 20px;
  position: sticky;
  z-index: 11;
}
.imageClass {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  position: sticky;
  z-index: 11;
}
.table-container th.selectedProClass,
.table-container td.selectedProClass,
.table-container th.imageClass,
.table-container td.imageClass {
  padding-left: 0.35rem;
  padding-right: 0.35rem;
}
.barCodeProClass {
  width: 12%;
}
.codeProClass {
  width: 14%;
}
.skuProClass {
  width: 12%;
}
.nameProClass {
  width: 32%;
  padding-left: 8px;
  align-items: center;
}
.nameNotPriceProClass {
  width: 38%;
  padding-left: 8px;
  align-items: center;
}
.importPriceProClass {
  width: 12%;
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}
.salePriceProClass {
  width: 12%;
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}
.stockProClass {
  width: 4%;
}
.statusProClass {
  width: 12%;
}
.actionProClass {
  width: 76px;
  position: relative;
  overflow: visible !important;
  z-index: 100 !important;
  isolation: isolate;
}
.product-code-text,
.product-name-text {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import Swal from 'sweetalert2'
  import ApiService from '@/core/services/api.service'
  import JwtService from '@/core/services/jwt.service'
  import { VclTable } from 'vue-content-loading'
  import { BASE_URL, PRODUCT_IMEI } from '@/utils/constants'
  import {
    currencyMask,
    unMaskPrice,
    removeAccents,
    convertPrice,
    makeToastSuccess,
    makeToastFaile,
  } from '@/utils/common'
  import { createFile, getFileName } from '@/utils/file-download'
  import axios from 'axios'
  import decounce from 'debounce'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import { getToastInstance } from '@/utils/toastHelper'
  import { VAT_AMOUNT } from '@/utils/enum'
  import ProductStockModal from '@/view/components/products/ProductStockModal.vue'
  import { mapActions, mapState, mapGetters } from 'vuex'
  import ProductImage from '@/view/components/products/ProductImage.vue'
  import { getPermissionsMixin } from '../../mixins'
  import companyCatalogFlagsMixin from '@/view/mixins/companyCatalogFlags.mixin'

  const PRODUCT_LIST_DISPLAY_COLUMNS_STORAGE_KEY = 'product-list-display-columns'

  export default {
    mixins: [getPermissionsMixin, companyCatalogFlagsMixin],
    computed: {
      ...mapActions(['setStore']),
      ...mapState({
        stores: (state) => state.stores,
      }),
      ...mapGetters(['listPermission']),
      activeFilterCount() {
        let count = 0
        // Đếm search
        if (this.search && this.search.trim()) {
          count++
        }
        // Đếm category
        if (this.selectedCategory) {
          count++
        }
        // Đếm brand
        if (this.selectedBrandId) {
          count++
        }
        // Đếm store
        if (this.selectedStore) {
          count++
        }
        // Đếm status
        if (this.selectedStatus) {
          count++
        }
        // Đếm product type
        if (this.selectedProductType) {
          count++
        }
        // Đếm VAT
        if (this.selectedVAT) {
          count++
        }
        // Đếm VAT rate
        if (this.selectedVATRate !== null && this.selectedVATRate !== undefined) {
          count++
        }
        // Đếm internal category
        if (this.selectedInternalCateId) {
          count++
        }
        return count
      },
      displayFields() {
        const fixedKeys = ['selected', 'actions']
        const visibleKeys = new Set([...fixedKeys, ...this.selectedDisplayColumns])
        return this.fields.filter((field) => visibleKeys.has(field.key))
      },
    },
    data() {
      return {
        isLoading: false,
        VAT_AMOUNT,
        checkUpdate: false,
        selectedProduct: '',
        mask: currencyMask,
        originalPrice: '',
        sellingPrice: '',
        productName: '',
        productId: '',
        showEditPriceModal: false,
        hoverPrice: false,
        parentProductId: '',
        childProductId: '',
        selectedProductType: '',
        listProductType: [
          { id: '', name: 'Thể loại' },
          { id: 1, name: 'Sản phẩm' },
          { id: 2, name: 'Sản phẩm theo IMEI' },
          { id: 4, name: 'Sản phẩm dịch vụ' },
        ],
        btnCreate: {
          fontWeight: '600!important',
        },
        selected: [],
        checkAllPro: false,
        selectedDisplayColumns: ['imageUrl', 'barCode', 'productCode', 'productName'],
        columnDisplayOptions: [
          { text: 'Hình ảnh', value: 'imageUrl' },
          { text: 'Mã vạch', value: 'barCode' },
          { text: 'Mã sản phẩm', value: 'productCode' },
          { text: 'SKU', value: 'sku' },
          { text: 'Tên sản phẩm', value: 'productName' },
          { text: 'Giá nhập', value: 'originalPrice' },
          { text: 'Giá bán', value: 'sellingPrice' },
        ],
        fields: [
          {
            key: 'selected',
            label: '',
            thStyle: { textAlign: 'center' },
            tdClass: 'selectedProClass',
            thClass: 'selectedProClass',
          },
          {
            key: 'imageUrl',
            label: 'Hình ảnh',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'imageClass',
            thClass: 'imageClass',
          },
          {
            key: 'barCode',
            label: 'Mã vạch',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'barCodeProClass',
            thClass: 'barCodeProClass',
          },
          {
            key: 'productCode',
            label: 'Mã sản phẩm',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'codeProClass',
            thClass: 'codeProClass',
          },
          {
            key: 'sku',
            label: 'SKU',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'skuProClass',
            thClass: 'skuProClass',
          },
          {
            key: 'productName',
            label: 'Tên sản phẩm',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'nameProClass',
            thClass: 'nameProClass',
          },
          {
            key: 'originalPrice',
            label: 'Giá nhập',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'importPriceProClass',
            thClass: 'importPriceProClass',
          },
          {
            key: 'sellingPrice',
            label: 'Giá bán',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'salePriceProClass',
            thClass: 'salePriceProClass',
          },
          {
            key: 'actions',
            label: '',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'actionProClass',
            thClass: 'actionProClass',
          },
        ],
        search: '',
        listProducts: [],
        listCategories: [],
        selectedCategory: null,
        linkGen: (pageNum) => {
          return pageNum === 1 ? '?' : `?page=${pageNum}`
        },
        page: 1,
        totalItem: 0,
        selectedStatus: '',
        listStatus: [
          { id: '', name: 'Trạng thái sản phẩm' },
          { id: 1, name: 'Đang bán' },
          { id: 2, name: 'Ngừng bán' },
        ],
        onLoading: false,
        selectedCate: '',
        cateOptions: [
          {
            data: [],
          },
        ],
        brandOptions: [
          {
            data: [],
          },
        ],
        filteredBrandOptions: [],
        filteredCateOptions: [],
        filteredOptions: [],
        optionsStore: [
          {
            data: [],
          },
        ],
        selectedBrandId: null,
        selectedStore: null,
        selectedBrandName: '',
        searchStock: '',
        selectedRowExcel: 'all',
        selectedListExcel: 'all',
        showHeaderExcel: false,
        indeterminate: false,
        allSelected: false,
        optionsHeader: [],
        selectedHeader: [],
        optionsHeaderDefault: [],
        barCode: '',
        numberOfPage: 1,
        selectedInternalCate: '',
        selectedInternalCateId: null,
        filteredInternalCateOptions: [],
        internalCateOptions: [
          {
            data: [],
          },
        ],
        fromNo: 0,
        toNo: 0,
        LIMIT_PAGE: 30,
        selectedVAT: null,
        selectedVATRate: null,
        selectingProduct: {
          productId: '',
          productName: '',
        },
        dataReadyCount: 0,
        totalDataSources: 3, // category, brand, store
      }
    },
    components: {
      KTCodePreview,
      VclTable,
      Autosuggest,
      ProductStockModal,
      ProductImage,
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Sản phẩm', route: '/products' },
        { title: 'Danh sách sản phẩm' },
      ])

      if (this.$route.params.updateIDImeiSuccess) {
        makeToastSuccess(this.$route.params.message)
        this.$route.params.updateIDImeiSuccess = false
      }

      if (this.$route.params.importProductSuccess) {
        makeToastSuccess(this.$route.params.message)
        this.$route.params.importProductSuccess = false
      }
    },
    created() {
      this.restoreDisplayColumns()
      this.fetchCategory()
      this.fetchBrand()
      this.getAllStoreAction({
        success: (data) => {
          this.handleSuccess(data)
          this.checkDataReady()
        },
        fail: this.handleFail,
      })
      this.checkViewOriginalPrice()
      this.$nprogress.done()
      this.$nprogress.remove()
    },
    watch: {
      selectedDisplayColumns(newVal) {
        this.saveDisplayColumns(newVal)
      },
      selectedHeader(newVal) {
        // Handle changes in individual flavour checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.optionsHeader.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
    },
    methods: {
      restoreDisplayColumns() {
        const availableColumnValues = new Set(this.columnDisplayOptions.map((item) => item.value))
        const defaultColumns = this.selectedDisplayColumns.filter((column) =>
          availableColumnValues.has(column),
        )
        try {
          const savedColumnsRaw = localStorage.getItem(PRODUCT_LIST_DISPLAY_COLUMNS_STORAGE_KEY)
          if (!savedColumnsRaw) {
            this.selectedDisplayColumns = defaultColumns
            return
          }

          const savedColumns = JSON.parse(savedColumnsRaw)
          if (!Array.isArray(savedColumns)) {
            this.selectedDisplayColumns = defaultColumns
            return
          }

          const validColumns = savedColumns.filter((column) => availableColumnValues.has(column))
          this.selectedDisplayColumns = validColumns.length ? validColumns : defaultColumns
        } catch (error) {
          this.selectedDisplayColumns = defaultColumns
        }
      },
      saveDisplayColumns(columns) {
        try {
          localStorage.setItem(PRODUCT_LIST_DISPLAY_COLUMNS_STORAGE_KEY, JSON.stringify(columns))
        } catch (error) {
          // Ignore localStorage errors (private mode, storage full, ...)
        }
      },
      handleSuccess(data) {
        this.isLoading = false
        data.map((element) => {
          this.optionsStore[0].data.push(element)
        })
        this.filteredOptions = [...this.optionsStore[0].data]
      },
      handleFail() {
        this.isLoading = false
      },
      ...mapActions(['getAllStoreAction']),
      popupModalPayment() {
        this.$bvModal.show('modal-product-stock')
      },
      updateProductStock(item) {
        this.selectingProduct = item
        this.popupModalPayment()
      },
      convertPrice,
      ...getToastInstance(),
      updateProduct: async function () {
        const data = {
          id: this.productId,
          originalPrice: this.originalPrice ? unMaskPrice(this.originalPrice) : 0,
          sellingPrice: this.sellingPrice ? unMaskPrice(this.sellingPrice) : 0,
          isUpdateChild: this.checkUpdate,
        }
        await ApiService.put('products/update-price', data)
          .then(async (response) => {
            const { status, message } = response.data
            if (status === 1) {
              this.fetchData()
              this.showEditPriceModal = !this.showEditPriceModal
              makeToastSuccess(message)
            } else {
              this.showEditPriceModal = !this.showEditPriceModal
              makeToastFaile(message)
            }
          })
          .catch(({ response }) => {
            const { status, message } = response.data
            if (status === 0) {
              makeToastFaile(message)
            }
          })
      },
      handleShowPriceModel(item) {
        this.showEditPriceModal = !this.showEditPriceModal
        this.selectedProduct = item
        this.productId = item.id
        this.productName = item.productName
        this.originalPrice = item.originalPrice
        this.sellingPrice = item.sellingPrice
      },
      findParentOrChild(item) {
        this.selectedCategory = null
        this.search = ''
        this.selectedStatus = ''
        this.selectedProductType = ''
        if (item.typeOfProduct === 3) {
          this.childProductId = ''
          this.parentProductId = item.parentProductId
          this.onFilter()
        } else if (item.typeOfProduct === 2) {
          this.parentProductId = ''
          this.childProductId = item.id
          this.onFilter()
        }
      },
      handleViewInventoryDetail(item) {
        item.productType === PRODUCT_IMEI
          ? this.$router.push({
              name: 'inventory-detail-imei',
              query: { id: item.id },
            })
          : this.$router.push({
              name: 'inventory-detail',
              query: { id: item.id },
            })
      },
      checkTypeOfProduct(item) {
        if (item.typeOfProduct === 1) {
          return 'mdi-star'
        } else if (item.typeOfProduct === 2) {
          return 'fa-sitemap'
        } else if (item.typeOfProduct === 3) {
          return 'fa-clipboard'
        }
      },
      checkTooltip(item) {
        if (item.typeOfProduct === 1) {
          if (item.productType === 3) {
            return 'Sản phẩm combo'
          } else {
            return 'Sản phẩm độc lập'
          }
        } else if (item.typeOfProduct === 2) {
          return 'Danh sách sản phẩm con'
        } else if (item.typeOfProduct === 3) {
          return 'Tới sản phẩm cha'
        }
      },
      checkPermission: function (condition) {
        return this.listPermission.includes(condition)
      },
      editItem: function (item) {
        // Lưu query params hiện tại (filters) vào sessionStorage
        const currentQuery = { ...this.$route.query }
        // Chỉ lưu các filter params, không lưu id nếu có
        delete currentQuery.id
        if (Object.keys(currentQuery).length > 0) {
          sessionStorage.setItem('listProductsFilters', JSON.stringify(currentQuery))
        }
        this.$router.push({
          name: 'update-product',
          query: { id: item.id },
        })
      },
      showDeleteAlert: function (item) {
        Swal.fire({
          title: 'Xóa sản phẩm!',
          text: 'Bạn có chắc muốn xóa sản phẩm này không ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xóa',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          position: 'top',
        }).then((result) => {
          if (result.value) {
            this.deleteItem(item)
          }
        })
      },
      fetchData: function () {
        // reset the check all products checkbox when user change pagination or search products
        if (this.checkAllPro === true) {
          this.checkAllPro = false
        }
        this.page = this.$route.query.page
        if (!this.page) {
          this.page = 1
        }
        if (this.selectedStore === null) {
          this.selectedStore = null
        }
        if (this.selectedBrandName.trim() === '') {
          this.selectedBrandId = null
        }
        if (this.selectedInternalCate.trim() === '') {
          this.selectedInternalCateId = null
        }
        if (this.selectedCate.trim() === '') {
          this.selectedCategory = null
        }

        const textSearch = this.search ? this.search.trim() : ''
        if (
          this.selectedCategory !== null ||
          this.selectedInternalCateId !== null ||
          textSearch !== '' ||
          this.selectedStatus !== '' ||
          this.selectedProductType !== ''
        ) {
          this.childProductId = ''
          this.parentProductId = ''
        }

        this.onLoading = true

        const param = {
          page: this.page,
          limit: this.LIMIT_PAGE,
          categoryId: this.selectedCategory,
          name: textSearch,
          status: this.selectedStatus,
          productType: this.selectedProductType,
          parentProductId: this.parentProductId,
          childProductId: this.childProductId,
          storeId: this.selectedStore,
          brandId: this.selectedBrandId,
          internalCateId: this.selectedInternalCateId,
          selectedVAT: this.selectedVAT,
          selectedVATRate: this.selectedVATRate,
        }
        const paramQuery = {
          params: param,
        }
        ApiService.query('products', paramQuery)
          .then(({ data }) => {
            this.listProducts = []
            this.totalItem = data.data.total_row
            this.fromNo = (this.page - 1) * this.LIMIT_PAGE + 1
            this.toNo = this.LIMIT_PAGE * this.page
            data.data.list_product.forEach((item, index) => {
              let product = {
                count: this.page >= 2 ? index + 1 + this.page * 10 - 10 : index + 1,
                selected: false,
                ...item,
              }
              this.listProducts.push(product)
            })
            this.numberOfPage = data.data.total_page
            this.onLoading = false
          })
          .catch(() => {
            this.onLoading = false
          })
      },
      fetchBrand: function () {
        this.listBrand = []
        const paramQuery = {
          params: {
            page: 1,
            pageSize: 1000,
            name: '',
          },
        }
        ApiService.query('brands', paramQuery).then((response) => {
          this.brandOptions[0].data = response.data.data.brands
          this.filteredBrandOptions = [...this.brandOptions[0].data]
          this.checkDataReady()
        })
      },
      checkDataReady() {
        this.dataReadyCount++
        if (this.dataReadyCount >= this.totalDataSources) {
          // Tất cả data đã load, restore filters và fetch data
          this.restoreFiltersFromQuery()
          this.fetchData()
        }
      },
      restoreFiltersFromQuery() {
        const query = this.$route.query

        // Restore search
        if (query.name) {
          this.search = query.name
        }

        // Restore category
        if (query.categoryId) {
          const categoryId = parseInt(query.categoryId)
          this.selectedCategory = categoryId
          // Tìm category name từ options
          const category = this.cateOptions[0].data.find((cat) => cat.id === categoryId)
          if (category) {
            this.selectedCate = category.name
          }
        }

        // Restore brand
        if (query.brandId) {
          const brandId = parseInt(query.brandId)
          this.selectedBrandId = brandId
          // Tìm brand name từ options
          const brand = this.brandOptions[0].data.find((brand) => brand.id === brandId)
          if (brand) {
            this.selectedBrandName = brand.name
          }
        }

        // Restore store
        if (query.storeId) {
          const storeId = parseInt(query.storeId)
          this.selectedStore = storeId
          // Tìm store name từ options
          const store = this.optionsStore[0].data.find((store) => store.id === storeId)
          if (store) {
            this.searchStock = store.name
          }
        }

        // Restore status
        if (query.status) {
          this.selectedStatus = query.status
        }

        // Restore product type
        if (query.productType) {
          this.selectedProductType = query.productType
        }

        // Restore VAT
        if (query.selectedVAT) {
          this.selectedVAT = query.selectedVAT
        }

        // Restore VAT rate
        if (query.selectedVATRate !== undefined && query.selectedVATRate !== null) {
          this.selectedVATRate = parseInt(query.selectedVATRate)
        }

        // Restore internal category
        if (query.internalCateId) {
          const internalCateId = parseInt(query.internalCateId)
          this.selectedInternalCateId = internalCateId
          // Tìm internal category name từ options
          const internalCate = this.internalCateOptions[0].data.find(
            (cat) => cat.id === internalCateId,
          )
          if (internalCate) {
            this.selectedInternalCate = internalCate.name
          }
        }
      },
      fetchCategory: function () {
        let param = {
          page: 1,
          limit: 1000,
          name: '',
          code: '',
        }
        let paramQuery = {
          params: param,
        }
        ApiService.query('categories', paramQuery).then(({ data }) => {
          this.cateOptions[0].data = []
          this.numberOfPage = data.data.total_page

          const flattenCategories = (categories, level = 0) => {
            categories.forEach((element) => {
              let name = ''
              if (level === 1) {
                name = '-' + element.name
              } else if (level === 2) {
                name = '--' + element.name
              } else if (level === 3) {
                name = '---' + element.name
              } else if (level === 4) {
                name = '----' + element.name
              } else if (level === 5) {
                name = '-----' + element.name
              } else if (level === 6) {
                name = '------' + element.name
              } else {
                name = element.name
              }

              let item = {
                id: element.id,
                suggestionName: name,
                name: element.name,
              }
              this.cateOptions[0].data.push(item)

              if (element.children && element.children.length > 0) {
                flattenCategories(element.children, level + 1)
              }
            })
          }

          flattenCategories(data.data.list_caterogy)

          this.filteredCateOptions = [...this.cateOptions[0].data]
          this.checkDataReady()
        })
      },
      checkStatus: function (item) {
        switch (item) {
          case 1:
            return 'Đang bán'
          case 2:
            return 'Ngừng bán'
          default:
            return ''
        }
      },
      deleteItem: async function (item) {
        let id = item.id
        ApiService.setHeader()
        ApiService.delete(`products/${id}`).then(({ data }) => {
          if (data.status === 1) {
            makeToastSuccess(data.message)
            this.fetchData()
          } else {
            makeToastFaile(data.message)
          }
        })
      },
      checkAll() {
        this.listProducts.forEach((element) => {
          element.selected = true
          if (this.checkAllPro === false) {
            element.selected = false
          }
        })
      },
      clickIndex2() {
        let count = 0
        this.listProducts.forEach((element) => {
          if (element.selected === false) {
            count += 1
            if (count === 5) {
              this.checkAllPro = false
            }
          }
        })
      },
      clickIndex() {
        if (this.checkAllPro == true) {
          this.checkAllPro = false
        } else {
          var count = 0
          this.listProducts.forEach((element) => {
            if (element.selected == true) {
              count += 1
              if (count == 10) {
                this.checkAllPro = true
              }
            }
          })
        }
      },
      checkViewOnly: function () {
        let count = 0
        if (this.listPermission.includes('PRODUCT_VIEW')) {
          count++
        }
        if (this.listPermission.includes('PRODUCT_UPDATE')) {
          count++
        }
        if (count === 1) {
          return true
        } else {
          return false
        }
      },
      showGenBarcodeAlert: function (item) {
        Swal.fire({
          title: 'Tạo mã vạch!',
          text: 'Bạn có chắc muốn tạo mã vạch cho sản phẩm này không ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Tạo',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          position: 'top',
        }).then((result) => {
          if (result.value) {
            this.genBarcode(item)
          }
        })
      },
      genBarcode: async function (item) {
        let id = item.id
        ApiService.setHeader()
        ApiService.post(`products/gen-barcode/${id}`).then(({ data }) => {
          if (data.status === 1) {
            makeToastSuccess(data.message)
            this.fetchData()
          } else {
            makeToastFaile(data.message)
          }
        })
      },
      excelModal: async function () {
        this.optionsHeaderDefault = [
          { text: 'Mã vạch', value: 'barCode', disabled: true },
          { text: 'Mã sản phẩm', value: 'productCode', disabled: true },
          { text: 'Tên sản phẩm', value: 'productName', disabled: true },
        ]
        this.selectedHeader = [
          'barCode',
          'productCode',
          'productName',
          'originalPrice',
          'sellingPrice',
          'totalQuantityInStock',
          'totalQuantityInTransfer',
          'status',
        ]
        this.optionsHeader = [
          { text: 'Mã vạch', value: 'barCode', disabled: true },
          { text: 'Mã sản phẩm', value: 'productCode', disabled: true },
          { text: 'Tên sản phẩm', value: 'productName', disabled: true },
          { text: 'Giá nhập', value: 'originalPrice', disabled: false },
          { text: 'Giá bán', value: 'sellingPrice', disabled: false },
          { text: 'Tồn kho', value: 'totalQuantityInStock', disabled: false },
          {
            text: 'Đang chuyển kho',
            value: 'totalQuantityInTransfer',
            disabled: false,
          },
          { text: 'Trạng thái', value: 'status', disabled: false },
        ]
        if (!this.checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')) {
          this.optionsHeader = this.optionsHeader.filter((item) => item.value !== 'originalPrice')
        }
        this.$refs['excel-modal'].show()
      },
      reportClick: function () {
        const query = []
        if (this.search && this.search !== '') {
          query.push('name=' + this.search.trim())
        }

        if (this.selectedStatus && this.selectedStatus !== '') {
          query.push(`status=${this.selectedStatus}`)
        }

        if (this.selectedCategory) {
          query.push(`categoryId=${this.selectedCategory}`)
        }

        if (this.selectedInternalCate) {
          query.push(`categoryInternalId=${this.selectedInternalCateId}`)
        }

        if (this.selectedStore && this.selectedStore !== 0) {
          query.push(`storeId=${this.selectedStore}`)
        }

        if (this.selectedBrandName.trim() === '') {
          this.selectedBrandId = null
        }

        if (this.selectedListExcel !== 'current') {
          if (
            this.selectedCategory !== null ||
            this.search !== '' ||
            this.selectedStatus !== '' ||
            this.selectedProductType !== ''
          ) {
            this.childProductId = ''
            this.parentProductId = ''
          }
          if (this.selectedStore === null) {
            this.selectedStore = 0
          }
          if (this.selectedBrandId !== null) {
            query.push(`brand=${this.selectedBrandId}`)
          }

          if (this.selectedProductType && this.selectedProductType !== '') {
            query.push(`productType=${this.selectedProductType}`)
          }

          if (this.selectedVAT) {
            query.push(`selectedVAT=${this.selectedVAT}`)
          }

          const queryParams = query.length ? query.join('&') : ''

          const url = `${BASE_URL}products/export-excel?${queryParams}`

          axios({
            url: url,
            method: 'get',
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${JwtService.getToken()}`,
            },
          })
            .then((response) => {
              const fileName = getFileName(response)
              createFile(response.data, fileName)
            })
            .catch((err) => {
              console.log('exportExcel error', err)
            })
        }
      },
      debounceInput: decounce(function () {
        this.onFilter()
      }, 500),
      onSelectedCate(option) {
        this.selectedCategory = option.item.id
        this.selectedCate = option.item.name
      },
      onSelectedBrand(option) {
        this.selectedBrandId = option.item.id
        this.selectedBrandName = option.item.name
      },
      onInputBrandChange(text) {
        this.selectedBrandName = text

        const filteredData = this.brandOptions[0].data.filter((item) => {
          return (
            removeAccents(item.name).toLowerCase().indexOf(removeAccents(text.toLowerCase())) > -1
          )
        })

        this.filteredBrandOptions = [...filteredData]
      },
      onInputCateChange(text) {
        this.selectedCate = text

        const filteredData = this.cateOptions[0].data.filter((item) => {
          return (
            removeAccents(item.name).toLowerCase().indexOf(removeAccents(text.toLowerCase())) > -1
          )
        })

        this.filteredCateOptions = [...filteredData]
      },
      checkViewOriginalPrice() {
        if (!this.checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')) {
          let listNew = this.fields.filter((item) => item.key !== 'originalPrice')
          this.fields = []
          listNew.forEach((element) => {
            this.fields.push(element)
          })
          this.columnDisplayOptions = this.columnDisplayOptions.filter(
            (item) => item.value !== 'originalPrice',
          )
          this.selectedDisplayColumns = this.selectedDisplayColumns.filter(
            (item) => item !== 'originalPrice',
          )
          for (let index = 0; index < this.fields.length; index++) {
            const element = this.fields[index]
            if (element.key === 'productName') {
              this.fields[index].tdClass = 'nameNotPriceProClass'
              this.fields[index].thClass = 'nameNotPriceProClass'
              break
            }
          }
        }
      },
      onSelected(option) {
        this.searchStock = option.item.name
        this.selectedStore = option.item.id
      },
      onInputChangeStore(text) {
        if (!text) {
          text = ''
        }
        this.searchStock = text

        /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
        const filteredData = this.optionsStore[0].data.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          )
        })

        this.filteredOptions = [...filteredData]
      },
      onFilter() {
        const query = {
          page: 1,
        }

        // Lưu các filter vào URL query
        if (this.search && this.search.trim()) {
          query.name = this.search.trim()
        }
        if (this.selectedCategory) {
          query.categoryId = this.selectedCategory
        }
        if (this.selectedBrandId) {
          query.brandId = this.selectedBrandId
        }
        if (this.selectedStore) {
          query.storeId = this.selectedStore
        }
        if (this.selectedStatus) {
          query.status = this.selectedStatus
        }
        if (this.selectedProductType) {
          query.productType = this.selectedProductType
        }
        if (this.selectedVAT) {
          query.selectedVAT = this.selectedVAT
        }
        if (this.selectedVATRate !== null && this.selectedVATRate !== undefined) {
          query.selectedVATRate = this.selectedVATRate
        }
        if (this.selectedInternalCateId) {
          query.internalCateId = this.selectedInternalCateId
        }

        this.$router.push({
          name: 'list-products',
          query: query,
        })
        this.fetchData()
      },
      clearFilters() {
        // Reset tất cả filters về giá trị mặc định
        this.search = ''
        this.selectedCategory = null
        this.selectedCate = ''
        this.selectedBrandId = null
        this.selectedBrandName = ''
        this.selectedStore = null
        this.searchStock = ''
        this.selectedStatus = ''
        this.selectedProductType = ''
        this.selectedVAT = null
        this.selectedVATRate = null
        this.selectedInternalCate = ''
        this.selectedInternalCateId = null
        this.parentProductId = ''
        this.childProductId = ''

        // Reset filtered options
        this.filteredCateOptions = [...this.cateOptions[0].data]
        this.filteredBrandOptions = [...this.brandOptions[0].data]
        this.filteredOptions = [...this.optionsStore[0].data]
        this.filteredInternalCateOptions = [...this.internalCateOptions[0].data]

        // Clear URL query và chỉ giữ lại page nếu có
        const query = {}
        if (this.$route.query.page) {
          query.page = 1
        }

        this.$router.push({
          name: 'list-products',
          query: query,
        })
        this.fetchData()
      },
      showHeader() {
        if (this.selectedRowExcel === 'row') {
          this.showHeaderExcel = true
        } else {
          this.showHeaderExcel = false
        }
      },
      toggleAll(checked) {
        this.selectedHeader = checked
          ? this.optionsHeader.map((x) => x.value)
          : this.optionsHeaderDefault.map((x) => x.value)
      },
      getLinkDoc(item) {
        return item.productType === PRODUCT_IMEI
          ? `#/products/inventory-detail-imei?id=${item.id}`
          : `#/products/inventory-detail?id=${item.id}`
      },
      fetchInternalCategory: function () {
        const param = {
          page: 1,
          limit: 1000,
          name: '',
          code: '',
        }
        let paramQuery = {
          params: param,
        }
        ApiService.setHeader()
        ApiService.query('productExternalCategory/get-all', paramQuery).then(({ data }) => {
          this.internalCateOptions[0].data = []
          data.data.forEach((element) => {
            let name = ''
            if (element.level === 1) {
              name = '- ' + element.name
            } else if (element.level === 2) {
              name = '- - ' + element.name
            } else if (element.level === 3) {
              name = '- - - ' + element.name
            } else if (element.level === 4) {
              name = '- - - - ' + element.name
            } else if (element.level === 5) {
              name = '- - - - - ' + element.name
            } else if (element.level === 6) {
              name = '- - - - - - ' + element.name
            } else {
              name = element.name
            }
            const item = {
              id: element.id,
              suggestionName: name,
              name: element.name,
            }
            this.internalCateOptions[0].data.push(item)
          })
          this.filteredInternalCateOptions = [...this.internalCateOptions[0].data]
        })
      },
      onSelectedInternalCate(option) {
        this.selectedInternalCateId = option.item.id
        this.selectedInternalCate = option.item.name
      },
      onInputInternalCateChange(text) {
        this.selectedInternalCate = text

        const filteredData = this.internalCateOptions[0].data.filter((item) => {
          return (
            removeAccents(item.name).toLowerCase().indexOf(removeAccents(text.toLowerCase())) > -1
          )
        })

        this.filteredInternalCateOptions = [...filteredData]
      },
      onClickToPrint() {
        const { href } = this.$router.resolve({
          name: 'print-product',
        })
        window.open(href, '_blank')
      },
      routeProduct(namePath) {
        if (
          (namePath === 'addProduct' || namePath === 'import-product') &&
          !this.ensureCanCreateProduct()
        ) {
          return
        }
        this.$router.push({
          name: `${namePath}`,
        })
      },
    },
  }
</script>

